<template>
  <div v-show="loading"> 
 	  <el-skeleton :rows="10" animated />
  </div>
  <!--begin::Stairstep History-->
  <div :class="widgetClasses" class="card" v-show="!loading">
    <!--begin::Body-->
    <div class="card-body py-3">
      <div class="row">
        <div v-show="loadingEarnings"> 
          <el-skeleton :rows="3" animated />
        </div>
        <div class="d-flex flex-wrap" v-show="!loadingEarnings">
            <!--begin::Stat-->
            <div class="border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 me-6 mb-3" align="center">
              <!--begin::Number-->
              <div align="center">
                <span class="svg-icon svg-icon-success me-2"> 
                </span>
                <div
                  class="fs-2 fw-bolder"
                  data-kt-countup="true"
                  data-kt-countup-value="4500"
                  data-kt-countup-prefix="$"
                >
                  {{numberWithCommas(Number(totalPersonalPoints).toFixed(2))}}
                </div>
              </div>
              <!--end::Number-->
              <!--begin::Label-->
              <div class="fw-bold fs-6 text-gray-400">&nbsp;&nbsp;YOUR PERSONAL ACCUMULATED PV</div>
              <!--end::Label-->
            </div>
            <!--end::Stat-->

            <!--begin::Stat-->
            <div class="border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 me-6 mb-3" align="center">
              <!--begin::Number-->
              <div align="center">
                <span class="svg-icon svg-icon-success me-2"> 
                </span>
                <div
                  class="fs-2 fw-bolder"
                  data-kt-countup="true"
                  data-kt-countup-value="4500"
                  data-kt-countup-prefix="$"
                >
                  {{numberWithCommas(Number(totalGroupPoints).toFixed(2))}}
                </div>
              </div>
              <!--end::Number-->
              <!--begin::Label-->
              <div class="fw-bold fs-6 text-gray-400">&nbsp;&nbsp;YOUR GROUP ACCUMULATED PV</div>
              <!--end::Label-->
            </div>
            <!--end::Stat-->
            <!--begin::Stat-->
            <div class="border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 me-6 mb-3" align="center">
              <!--begin::Number-->
              <div align="center">
                <span class="svg-icon svg-icon-success me-2"> 
                </span>
                <div
                  class="fs-2 fw-bolder"
                  data-kt-countup="true"
                  data-kt-countup-value="4500"
                  data-kt-countup-prefix="$"
                >
                  {{numberWithCommas(Number(totalSstepCom).toFixed(2))}}
                </div>
              </div>
              <!--end::Number-->
              <!--begin::Label-->
              <div class="fw-bold fs-6 text-gray-400">&nbsp;&nbsp;YOUR TOTAL STAIR STEP EARNINGS</div>
              <!--end::Label-->
            </div>
            <!--end::Stat-->
            <!--begin::Stat-->
            <div class="border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 me-6 mb-3" align="center">
              <!--begin::Number-->
              <div align="center">
                <span class="svg-icon svg-icon-success me-2"> 
                </span>
                <div
                  class="fs-2 fw-bolder"
                  data-kt-countup="true"
                  data-kt-countup-value="4500"
                  data-kt-countup-prefix="$"
                >
                  {{numberWithCommas(totalSstepComThisMonth.toFixed(2))}}
                </div>
              </div>
              <!--end::Number-->
              <!--begin::Label-->
              <div class="fw-bold fs-6 text-gray-400">&nbsp;&nbsp;YOUR TOTAL STAIR STEP EARNINGS FOR THIS MONTH</div>
              <!--end::Label-->
            </div>
            <!--end::Stat-->
        </div>
        
      </div>
      <div class="row">
        <div class="col-lg-4">
          <div class="row mt-5">
            <div class="col-lg-4 mb-3">
              <input type="text" class="form-control form-control-lg form-control-solid mb-2" placeholder="year" name="year" readonly v-model="year">
            </div>
            <div class="col-lg-6">
              <select class="form-select form-select-solid form-select-lg fw-bold mb-2" name="month" v-model="month">
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
                </select>
            </div>
            <div class="col-lg-2 text-center mb-1">
              <button
              type="submit"
              class="btn btn-primary er fs-4 px-8 py-2 mt-1 mb-1"
              v-on:click="loadSStep_summary()">
              <span class="indicator-label">
                  View
                </span>
                <span class="indicator-progress">
                  Please wait...
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-2"
                  ></span>
                </span>
            </button>
            </div>
          </div>
        </div>
        <div class="col-lg-1"></div>
        <div class="col-lg-7">
          <div class="row col-lg-12">
            <!--begin::Table container-->
            <div class="table-responsive">
              <!--begin::Table-->
              <table class="table align-middle gs-0 gy-4">
                <!--begin::Table head-->
                <thead>
                  <tr class="fw-bolder text-muted bg-light">
                    <th class="ps-4 min-w-70px rounded-start">Ref. #</th>
                    <th class="min-w-250px">Business Partners</th>
                    <th class="min-w-150px">Personal PV</th>
                    <th class="min-w-150px">Group PV</th>
                    <th class="min-w-150px">Commission</th>
                  </tr>
                </thead>
                <!--end::Table head-->
                <!--begin::Table body-->
                <tbody>
                  <template v-for="(item, index) in list" :key="index">
                    <tr>
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{index + 1}}</td>
                      
                      <td>
                        <div class="d-flex align-items-center">
                          <div>
                            <a class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{item.fullname.toUpperCase()}}</a>
                            <span class="text-muted font-weight-bold d-block">{{item.rusid.toUpperCase()}}</span>
                            <span class="text-muted font-weight-bold d-block">Rank: {{item.rank.toUpperCase()}}</span>
                          </div>
                        </div>
                      </td>
                      <td>{{numberWithCommas(item.psnPosPV)}}</td>
                      <td>{{numberWithCommas(item.grpPosPV)}}</td>
                      <td>{{numberWithCommas(item.totComPV)}}{{ getTotalTEST(item.totComPV, index)}}
                      </td>
                      
                    </tr>
                  </template> 
                </tbody>
                <!--end::Table body-->
              </table>
              <!--end::Table-->
            </div>
            <!--end::Table container-->
          </div>
          
        </div>
      </div>
      
    </div>
    <!--begin::Body-->
     <pagination :pagination="pagination" :callback="reorderhistory" :options="paginationOptions"></pagination>
  </div>
  <!--end::Stairstep History-->
</template>

<script lang="ts">
var total = 0.00;
var maxcount = 0;
import { defineComponent } from "vue";
import {loadSStepSummary, sstepEarnings}  from "@/api/stairstep";

export default defineComponent({
  name: "stairstephistory", 
  methods: {
    async getThisMonthAndYear(){
      this.loading = true;
      var d = new Date();
      var m = d.getMonth();
      var y = d.getFullYear();
      this.month = m + 1;
      this.year = y;
      this.loading = false;
    },  
    async loadSStep_summary(){
      
      this.totalSstepComThisMonth = 0.00;
      console.log("this.totalSstepComThisMonth = " + this.totalSstepComThisMonth);
      this.loading = true;
      var params = {
        "month" : this.month,
        "year" : this.year
      }
      const response = await loadSStepSummary(params);
      this.list = response.data.pageList;
      maxcount = this.list.length;
      this.loading = false;
      
    },
    async getSstepEarnings(){
      this.loadingEarnings = true;
      const response = await sstepEarnings();
      this.totalSstepCom = response.data.totalSstepCom;
      this.totalPersonalPoints = response.data.totalPersonalPoints;
      this.totalGroupPoints = response.data.totalGroupPoints;
      this.loadingEarnings = false;
    },
    getTotalTEST(param1, param2){
      total = total + parseFloat(param1);
      console.log(total);
      console.log("maxcount - " + maxcount );
      console.log("param2 - " + param2 );
      if(param2 <= maxcount){
        this.totalSstepComThisMonth = total;
        total = 0.00;
        maxcount = 0;
      }
    },
    updateTotal(){
      this.totalSstepComThisMonth = total;
      console.log("total - " + total);
    }
    
  },
  mounted(){
      this.getThisMonthAndYear();
      this.loadSStep_summary();
      this.getSstepEarnings();
      
      
  },
  computed: {
  },
  data(){
      return {
        month:0,
        year: 0,
        list : [],
        loading: true,
        totalSstepCom: 0.00,
        totalPersonalPoints: 0.00,
        totalGroupPoints: 0.00,
        totalSstepComThisMonth: 0.00,
        loadingEarnings: true,
      }
  },
  components: {
  },
  props: {
    widgetClasses: String
  }
});

</script>
